import React from 'react'

import { Divider } from 'antd'

import './FormHeader.css'

const FormHeader = ({ title, orientation, type, color = '#bbbbbb', fontSize = '17px', className }) => {
  return (
    <>
      <Divider
        className={`form-header__title ${className}`}
        style={{ color, fontSize }}
        orientation={orientation}
        type={type}
      >
        {title}
      </Divider>
    </>
  )
}

export default FormHeader
